<template>
    <div :class="customClass" class="datePicker">
        <van-field
            v-model="date"
            :name="paramName"
            :label="label"
            :left-icon="leftIcon"
            :right-icon="rightIcon"
            :rules="rules"
            readonly
            :required="required"
            clickable
            :disabled="disabled"
            :placeholder="placeholder"
            @click="onClick"
        />
        <van-popup v-model="showDate" position="bottom">
            <van-datetime-picker
                v-model="currentDate"
                :type="type"
                :title="title"
                :min-date="minDate"
                :max-date="maxDate"
                @cancel="showDate = false"
                @confirm="confirmCall"
            />
        </van-popup>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: '选择日期'
        },
        rules: {
            type: Array,
            default: () => {
                return []
            }
        },
        required: {
            type: Boolean,
            default: false
        },
        customClass: {
            type: String,
            default: ''
        },
        format: {
            type: String,
            default: 'YYYY-MM-DD HH:mm'
        },
        initValue: {
            type: String,
            default: ''
        },
        label: {
            type: String,
            default: ''
        },
        leftIcon: {
            type: String,
            default: ''
        },
        rightIcon: {
            type: String,
            default: ''
        },
        placeholder: {
            type: String,
            default: '请选择日期'
        },
        paramName: {
            type: String,
            default: 'datePicker'
        },
        minDate: {
            type: Date
        },
        maxDate: {
            type: Date
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        let type = 'datetime'
        switch (this.format) {
            case 'YYYY-MM-DD':
                type = 'date'
                break
            case 'YYYY-MM':
                type = 'year-month'
                break
            case 'MM-DD':
                type = 'month-day'
                break
            case 'HH:mm' || 'HH:mm:ss':
                type = 'time'
                break
            default:
                break
        }
        return {
            date: this.initValue,
            [this.paramName]: this.initValue,
            currentDate: this.initValue ? new Date(this.initValue.replace(/-/g, '/')) : (type === 'time' ? this.$moment().format(this.format) : new Date()), // ios不支持 2020-07-20 写法
            showDate: false,
            type
        }
    },
    methods: {
        onClick() {
            if(this.disabled) return
            this.showDate = true
        },
        confirmCall(val) {
            
            this.date = this.type === 'time' ? val : this.$moment(val).format(this.format)
            this.$emit('onOk')
            this.showDate = false
        }
    },
    watch: {
        initValue(newVal) {
            this.date = newVal
        }
    }
}
</script>
<style lang="less"></style>
